import { clientePedido } from '../../apiClient/index'

const AVISOS_TIMEOUT_MS = 5000
const AVISOS_ENDPOINT = '/api/Avisos/Get'

function getAuthHeaders() {
  try {
    const token = JSON.parse(localStorage.getItem('SistemaPedidoToken'))

    if (!token || !token.Sesion) {
      return {}
    }

    return {
      Authorization: `Bearer ${btoa(token.Sesion)}`
    }
  } catch (error) {
    console.error('[AvisosImportantes] No se pudo leer el token de autenticacion.', error)
    return {}
  }
}

function buildAvisosUrl(usuarioId) {
  const baseURL = clientePedido && clientePedido.defaults ? clientePedido.defaults.baseURL : '/'
  const normalizedBaseURL = baseURL && /\/$/.test(baseURL) ? baseURL : `${baseURL || '/'}${baseURL === '/' ? '' : '/'}`
  const requestUrl = new URL(AVISOS_ENDPOINT, normalizedBaseURL)

  if (typeof usuarioId !== 'undefined' && usuarioId !== null && usuarioId !== '') {
    requestUrl.searchParams.set('usuarioId', usuarioId)
  }

  return requestUrl.toString()
}

function isAbortError(error) {
  return error && (error.name === 'AbortError' || error.code === 'ERR_ABORTED')
}

function normalizeAvisosPayload(payload) {
  if (Array.isArray(payload)) {
    return payload
  }

  if (payload && Array.isArray(payload.Result)) {
    return payload.Result
  }

  if (payload && Array.isArray(payload.Datos)) {
    return payload.Datos
  }

  return null
}

const moduloAvisosImportantes = {
  namespaced: true,
  state: {
    avisos: [],
    estado: 'idle'
  },
  mutations: {
    setAvisos(state, payload) {
      state.avisos = Array.isArray(payload) ? payload : []
    },
    setEstado(state, payload) {
      state.estado = payload
    }
  },
  actions: {
    async getAvisos(context, payload = {}) {
      const usuarioId = payload.usuarioId
      const controller = payload.controller instanceof AbortController ? payload.controller : new AbortController()
      const timeoutMs = typeof payload.timeoutMs === 'number' ? payload.timeoutMs : AVISOS_TIMEOUT_MS
      const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs)

      context.commit('setEstado', 'loading')

      try {
        const response = await fetch(buildAvisosUrl(usuarioId), {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            ...getAuthHeaders()
          },
          signal: controller.signal
        })

        if (!response.ok) {
          console.error('[AvisosImportantes] La API devolvio un estado no exitoso.', response.status)
          context.commit('setAvisos', [])
          context.commit('setEstado', 'hidden')
          return []
        }

        let payloadResponse = null

        try {
          payloadResponse = await response.json()
        } catch (error) {
          console.error('[AvisosImportantes] La API devolvio un payload invalido.', error)
          context.commit('setAvisos', [])
          context.commit('setEstado', 'hidden')
          return []
        }

        const avisos = normalizeAvisosPayload(payloadResponse)

        if (!Array.isArray(avisos)) {
          console.error('[AvisosImportantes] La API devolvio un payload invalido.', payloadResponse)
          context.commit('setAvisos', [])
          context.commit('setEstado', 'hidden')
          return []
        }

        context.commit('setAvisos', avisos)
        context.commit('setEstado', avisos.length > 0 ? 'ready' : 'hidden')
        return avisos
      } catch (error) {
        if (isAbortError(error)) {
          console.warn('[AvisosImportantes] La solicitud fue abortada por timeout o desmontaje.', error)
        } else {
          console.error('[AvisosImportantes] Fallo la carga de avisos importantes.', error)
        }

        context.commit('setAvisos', [])
        context.commit('setEstado', 'hidden')
        return []
      } finally {
        window.clearTimeout(timeoutId)
      }
    }
  }
}

export default moduloAvisosImportantes